import { AnnouncementImageSize, parseAnnouncementImageSize } from '@pya-mms/common';
import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';
import theme from '../../../theme';
import SignedImage from '../../AWS';
import {
  ANNOUNCEMENT_IMAGE_DISPLAY_WIDTH,
  announcementImageFrameMargin,
} from '../../Announcements/announcementImageLayout';
import { Text } from '../Text';

const MarkdownRoot = styled.div`
  color: ${theme.colors.general.text};
  font-size: 14px;
  line-height: 1.6;

  h2,
  h3 {
    color: ${theme.colors.general.black};
    margin: 16px 0 8px;
  }

  p {
    margin: 0 0 12px;
  }

  ul,
  ol {
    margin: 0 0 12px 20px;
  }

  a {
    color: ${theme.colors.general.primary};
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
`;

const MarkdownImage = styled.div<{ $size: AnnouncementImageSize }>`
  width: ${(p) => ANNOUNCEMENT_IMAGE_DISPLAY_WIDTH[p.$size]};
  max-width: 100%;
  margin: ${(p) => announcementImageFrameMargin(p.$size)};
`;

type MarkdownContentProps = {
  content: string;
};

const MarkdownContent: FC<MarkdownContentProps> = ({ content }) => {
  if (!content?.trim()) {
    return (
      <Text size="sm" color="textSecondary">
        No content.
      </Text>
    );
  }

  return (
    <MarkdownRoot>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
          img: ({ src, alt, title }) => (
            <MarkdownImage $size={parseAnnouncementImageSize(title)}>
              <SignedImage src={src || ''} alt={alt || ''} objectFit="contain" height="auto" />
            </MarkdownImage>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </MarkdownRoot>
  );
};

export default MarkdownContent;
